import { assertExists } from '@blocksuite/global/utils';
function getClosestEditorContainer(element) {
    const container = element.closest('affine-editor-container');
    assertExists(container);
    return container;
}
export function listenToThemeChange(currentELement, callback) {
    const container = getClosestEditorContainer(currentELement);
    return container.themeObserver.on(callback);
}
export function getThemePropertyValue(currentELement, name) {
    const container = getClosestEditorContainer(currentELement);
    return container.themeObserver.cssVariables?.[name];
}
//# sourceMappingURL=utils.js.map